import { render, staticRenderFns } from "./TrainingItem.vue?vue&type=template&id=35f438d1&scoped=true&"
import script from "./TrainingItem.vue?vue&type=script&lang=js&"
export * from "./TrainingItem.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItem.vue?vue&type=style&index=0&id=35f438d1&lang=scss&scoped=true&"
import style1 from "./TrainingItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f438d1",
  null
  
)

export default component.exports